<template>
  <div id="app">
    <TopPage></TopPage>
  </div>
</template>

<script>
import TopPage from './components/TopPage';

export default {
  name: 'app',
  components: {
    TopPage,
  },
};
</script>

<style src="normalize.css"></style>
<style src="./assets/stylesheets/common.scss" lang="scss"></style>



// WEBPACK FOOTER //
// App.vue?0cff669a